var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"field field_all"},[_c('app-checkbox',{ref:"checkbox",attrs:{"name":_vm.name,"title":_vm.translations.all,"checked":_vm.checked},on:{"change":function($event){_vm.$emit('change', $event)}}}),_c('app-button-move')],1)}
var staticRenderFns = []

export { render, staticRenderFns }